<script>
  import DropDown from '../../components/DropDown.svelte';
  import DataGrid from '../../components/DataGrid/DataGrid.svelte';
  import GridSearch from '../../components/GridSearch.svelte';
  import TaskOutlookItem from './TaskOutlookItem.svelte';
  import TaskOutlookItemMonth from './TaskOutlookItemMonth.svelte';
  import Loader from '../../components/Loader.svelte';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { setContext } from 'svelte';
  import {
    searchKeyByValue,
    mergeOutlookArr,
    configItem,
    dbDateFormat,
    getURLParameters,
    getUrlFilters,
    clearUrlParams,
  } from 'components/Helper.js';
  import { dashboardData, getDashboardData, setDashboardData } from '../../stores/dashboard.js';
  import { loadingData } from '../../stores/loadingData';
  export let dashboardLeftObj;
  import moment from 'moment';
  import { Popover } from 'bootstrap';
  import EditTaskModal from '../EditTaskModal.svelte';
  import { Modal } from 'bootstrap';
  import CreateGroup from './CreateGroup.svelte';
  import TaskGroup from './TaskGroup.svelte';
  let bulkActionList = [
    { id: 1, text: 'Open' },
    { id: 2, text: 'Closed' },
    { id: 3, text: 'Completed' },
    { id: 4, text: 'Action Queue' },
  ];

  let fields = [
    { id: 1, text: 'Task' },
    { id: 2, text: 'Delete' },
    { id: 3, text: 'Completed' },
    { id: 4, text: 'Complete Task' },
  ];

  let assignee = [{ id: 1, text: 'Assignee' }];

  let taskType = [
    { id: 1, text: 'Client' },
    { id: 2, text: 'Internal' },
  ];

  let status = [
    { id: 1, text: 'Open' },
    { id: 2, text: 'Closed' },
    { id: 2, text: 'Completed' },
    { id: 2, text: 'Action' },
    { id: 2, text: 'Que' },
  ];

  let task_category = configItem.allTaskStatus;
  let taskComplianceStatusType = configItem.allComplianceStatus;
  let taskRiskRankType = configItem.riskRank;
  let taskServiceType = [];

  import { client } from 'root/api/index.js';

  import { displayTimeAgo } from 'components/Helper.js';
  import { onMount, onDestroy, getContext } from 'svelte';
  const showDialog = getContext('showDialog');
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let outlookData = [];
  let isPaginationLoading = false;
  let datePickerRef;
  let initialDatePickerRef;
  import { downloadCsvFile, downloadFile } from 'components/Helper.js';
  const downloadCsv = (comeFrom) => {
    client
      .exportTaskOutlookList({
        ...extraFilter,
        comeFrom,
      })
      .then((response) => response.blob())
      .then(async (result) => {
        downloadFile(
          result,
          comeFrom == 'client'
            ? 'task_outlook_client-export.xlsx'
            : 'task_outlook_list-export.xlsx',
        );
        // downloadCsvFile(result, "task_outlook.csv");
      });
  };

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      var existing = Popover.getInstance(el);
      if (existing) {
        existing.dispose();
      }
      el.remove();
    });
    var elements = document.querySelectorAll('.clone_popup');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  let allMonths = [];
  const getTaskOutlookList = () => {
    if (extraFilter.units.length == 0) {
      return false;
    }
    allMonths = [];
    if (extraFilter.fromDate != '' && extraFilter.toDate != '') {
      let totalMonth = Math.ceil(
        moment(extraFilter.toDate).diff(moment(extraFilter.fromDate), 'months', true),
      );
      if (totalMonth <= 1) {
        allMonths = [
          {
            fromDate: extraFilter.fromDate,
            toDate: extraFilter.toDate,
          },
        ];
      } else {
        for (var i = 0; i < totalMonth; i++) {
          allMonths.push({
            fromDate:
              i == 0
                ? extraFilter.fromDate
                : moment(extraFilter.fromDate).add(i, 'M').startOf('month').format('YYYY-MM-DD'),
            toDate:
              i == totalMonth - 1
                ? extraFilter.toDate
                : moment(extraFilter.fromDate).add(i, 'M').endOf('month').format('YYYY-MM-DD'),
          });
        }
      }
    } else {
      for (var i = 0; i < 12; i++) {
        allMonths.push({
          fromDate: moment().month(i).startOf('month').format('YYYY-MM-DD'),
          toDate: moment().month(i).endOf('month').format('YYYY-MM-DD'),
        });
      }
    }
    for (var i in allMonths) {
      loadData(i);
    }
  };

  let expandLabels = [];
  const checkAllLoaded = () => {
    var allLoaded = true;
    for (var i in allMonths) {
      if (allMonths[i].response == undefined) {
        allLoaded = false;
      }
    }
    if (allLoaded) {
      filterCount = 0;
      outlookData = [];
      for (var i in allMonths) {
        let response = allMonths[i].response;
        filterCount += response.data.countRecords;
        outlookData = [...outlookData, ...response.data.payload];
        totalPages += response.data.pagination.totalPage;
      }
      var allData = [];
      for (var i in outlookData) {
        var rowData = [];
        for (var j in outlookData[i].data) {
          for (var k in outlookData[i].data[j].data) {
            let data = outlookData[i].data[j].data[k];
            rowData.push(data);
          }
        }
        allData.push({
          label: outlookData[i].label,
          checked: false,
          driver: expandLabels.indexOf(outlookData[i].label) != -1,
          _children: rowData,
        });
      }
      tableData = allData;
      isPaginationLoading = false;
    }
  };
  const loadData = (i) => {
    isPaginationLoading = true;
    client
      .taskOutlookList(pageSize, pageNumber, {
        ...extraFilter,
        fromDate: allMonths[i].fromDate,
        toDate: allMonths[i].toDate,
      })
      .then((response) => {
        allMonths[i].response = response;
        checkAllLoaded();
      });
  };

  let availableWidth = 0;
  const setColumnUnitWidth = () => {
    let width = {
      clientName: 150,
      unitProjectName: 150,
      name: 0,
      purpose: 0,
      requirement: 0,
      responsibleParty: 150,
      assigneeUserName: 150,
      openDate: 100,
      dueDate: 100,
      completeDate: 100,
      completeUserName: 100,
    };
    let totalWidth = 220;
    columns.map((item) => {
      if (width[item.key]) {
        totalWidth += width[item.key];
      }
    });
    availableWidth = window.screen.width - totalWidth;
    availableWidth = availableWidth < 100 ? 100 : availableWidth;

    let totalColumn = 0;
    if (searchKeyByValue(columns, 'key', 'purpose') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'name') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'requirement') != -1) {
      totalColumn++;
    }
    if (totalColumn > 0) {
      availableWidth /= totalColumn;
    }
  };
  let tableColumnLoaded = false;

  let columnLoaded = false;
  let columns = [];

  let checkedLabels = [];
  const changeCheckboxLabel = (flag, label) => {
    if (flag == 'checked') {
      checkedLabels.push(label);
    } else {
      checkedLabels.splice(expandLabels.indexOf(label), 1);
    }
  };
  const selectAction = (type) => {
    if (ref.getData().filter((item) => item.checked).length == 0) {
      showDialog({
        title: '',
        message: 'Please select month.',
      });
    } else {
      loadingData.set(true);
      setTimeout(() => {
        let allData = ref.getData().map((item) => {
          if (type == 1) {
            item.driver = item.checked == true ? true : item.driver;
          } else {
            item.driver = item.checked == true ? false : item.driver;
          }
          item.checked = false;
          return item;
        });
        document.getElementById('chk_select_all').checked = false;
        ref.setData(allData);
        changeExpandLabel();
      }, 250);
    }
  };

  let allColumns = [
    {
      name: `<div class="checkbox c-checkbox"><label><input type="checkbox" id="chk_select_all"> <span class="check-img"></span></label></div>`,
      key: 'label',
      headerSort: false,
      resizable: false,
      width: 30,
      minWidth: 30,
      formatter: function (cell, formatterParams) {
        if (cell.getValue()) {
          let checked = cell.getData().checked ? 'checked' : '';
          return (
            `<div class="checkbox c-checkbox" style="display: inline-block;"><label><input type="checkbox" ` +
            checked +
            `> <span class="check-img"></span></label></div>` +
            '<span>' +
            cell.getValue() +
            '</span>'
          );
        }
      },
      cellClick: function (e, cell) {
        if (e.target.type == 'checkbox') {
          let row = cell.getRow();
          let data = row.getData();
          if (e.target.checked) {
            data.checked = true;
          } else {
            data.checked = false;
          }
          row.update(data);
        }
      },
      headerClick: function (e, column) {
        if (e.target.type == 'checkbox') {
          let allData = ref.getData().map((item) => {
            item.checked = e.target.checked;
            return item;
          });
          ref.setData(allData);
        }
      },
    },
    {
      name: 'Client Name',
      key: 'clientName',
      headerSort: false,
    },
    // Risk rank column
    {
      key: 'riskRank',
      name: 'Risk Rank',
      headerSort: false,
      width: 180,
      formatter: (cell) => {
        const cellData = cell.getData();
        const riskNum = cellData.riskRank;
        const { name, icon } = configItem.riskRank.find((item) => item.id === riskNum) || {};
        if (!name || !cellData?.id) return '';
        return `<span class='status-pill blackText'><span class="td-risk-rank-${riskNum}" style="max-width: 55px"><img alt="" class="icon-16" src="/images/${icon}" /></span></span>`;
      },
    },
    {
      name: 'Internal',
      key: 'unitProjectName',
      headerSort: false,
    },
    {
      name: 'Task',
      key: 'name',
      headerSort: false,
      tooltip: true,
      formatter: function (cell, formatterParams) {
        return cell.getValue()
          ? "<span class='" +
              (cell.getData().isOverdue == 0 ? 'color-blue' : '') +
              "'>" +
              cell.getValue() +
              '</span>'
          : '';
      },
    },
    {
      name: 'Purpose',
      key: 'purpose',
      headerSort: false,
      tooltip: true,
    },
    {
      name: 'Requirement',
      key: 'requirement',
      headerSort: false,
      tooltip: true,
    },
    {
      name: '\tResponsible Party',
      key: 'responsibleParty',
      headerSort: false,
      formatter: function (cell, formatterParams) {
        return cell.getData().responsiblePartyLabel;
      },
    },
    {
      name: 'Assignee Name',
      key: 'assigneeUserName',
      active: 1,
      headerSort: false,
    },
    {
      name: 'Open Date',
      key: 'openDate',
      headerSort: false,
    },
    {
      name: 'Due Date',
      key: 'dueDate',
      headerSort: false,
    },
    {
      key: 'status',
      name: 'Task Status',
      headerSort: false,
      width: 180,
      formatter: (cell) => {
        const cellData = cell.getData();
        const scheduleId = 3;
        const statusNum = cellData.isSchedule ? scheduleId : cellData.status;
        const statLabel = configItem.allTaskStatus.find((item) => item.id === statusNum)?.name;
        if (!statLabel) return '';
        return `<span class='text-muted status-pill'><span class="td-status-${statusNum}" style="max-width: 140px">${statLabel}</span></span>`;
      },
    },
    {
      key: 'complianceStatus',
      name: 'Compliance Status',
      headerSort: false,
      width: 180,
      formatter: (cell) => {
        const cellData = cell.getData();
        const pendingId = 2;
        const statusNum = cellData.isSchedule ? pendingId : cellData.complianceStatus;
        const statLabel = configItem.allComplianceStatus.find(
          (item) => item.id === statusNum,
        )?.name;
        if (!statLabel || !cellData?.id) return '';
        return `<span class='text-muted status-pill'><span class="td-compliance-${statusNum}" style="max-width: 140px">${statLabel}</span></span>`;
      },
    },
    {
      name: '\tCompleted Date',
      key: 'completeDate',
      headerSort: false,
    },
    {
      name: 'Completed By',
      key: 'completeUserName',
      headerSort: false,
    },
  ];

  let tableColumns = [];
  let urlParamExtraFilter;

  import { getMasterData, setMasterData, masterData } from '../../stores/masterData';
  import {
    getOutlookData,
    setOutlookData,
    outlookData as outlookDataStore,
  } from '../../stores/outlookData';

  const handleFilterParams = () => {
    const { tab } = getURLParameters();
    if (tab !== 'outlook') return null;
    const paramFilters = getUrlFilters();
    urlParamExtraFilter = {
      ...(paramFilters || {}),
    };
    if (paramFilters?.priority) {
      const priorityIdList = paramFilters.priority.map((item) => item.id);
      configPriority = configPriority.map((item) => {
        item.checked = priorityIdList.includes(item.id);
        return item;
      });
    }
    if (paramFilters?.taskComplianceStatusType) {
      const complianceList = paramFilters.taskComplianceStatusType.map((item) => item.id);
      taskComplianceStatusType = taskComplianceStatusType.map((item) => {
        item.checked = complianceList.includes(item.id);
        return item;
      });
    }
    if (paramFilters?.taskRiskRankType) {
      const riskRankIdList = paramFilters.taskRiskRankType.map((item) => item.id);
      taskRiskRankType = taskRiskRankType.map((item) => {
        item.checked = riskRankIdList.includes(item.id);
        return item;
      });
    }
    setDashboardData({
      ...getDashboardData(),
      fromDate: paramFilters?.fromDate || '',
      toDate: paramFilters?.toDate || '',
      initialFromDate: paramFilters?.initialFromDate || '',
      initialToDate: paramFilters?.initialToDate || '',
      taskServiceType: paramFilters?.taskServiceType || [],
      taskActivityTypes: paramFilters?.taskActivityTypes || [],
      taskComplianceStatusType: paramFilters?.taskComplianceStatusType || [],
      taskRiskRankType: paramFilters?.taskRiskRankType || [],
      task_category: paramFilters?.task_category || [],
    });
    return clearUrlParams();
  };

  onMount(() => {
    getUnitDetail();
    bindTagify();
    handleFilterParams();

    client.outlookGridColumnList().then((response) => {
      let oldColumns = [];
      let dbData = response.data.payload;
      let oldAllColumns = [...allColumns];
      for (var i in oldAllColumns) {
        let dbKey = searchKeyByValue(dbData, 'column_name', oldAllColumns[i].key);
        oldAllColumns[i].checked = true;
        if (dbKey !== -1) {
          if (dbData[dbKey].active == 1) {
            oldColumns.push(oldAllColumns[i]);
          } else {
            oldAllColumns[i].checked = false;
          }
        }
      }
      allColumns = oldAllColumns;
      columns = oldColumns;
      tableColumns = allColumns.map((item) => {
        item.title = item.name;
        item.field = item.key;
        item.visible = item.checked;
        return item;
      });
      columnLoaded = true;
      setColumnUnitWidth();
    });

    // client.outlookGridColumnList().then((response) => {
    //     allColumns=response.data.payload.map(item=>{
    //       item.key=item.column_name
    //       item.label=item.name
    //       item.checked=item.active==1
    //       return item;
    //     })
    //     columns=allColumns.filter(item=>item.checked)

    //     columnLoaded=true
    //     setColumnUnitWidth()
    // });
  });
  const unsubscribeOutlookData = outlookDataStore.subscribe((state) => {
    if (state != undefined) {
      expandLabels = state.outlookSetting;
    }
  });

  import InfiniteScroll from 'components/DataTable/InfiniteScroll.svelte';

  let defaultFilter = {
    units: [],
    tasks: [],
    searchKeyword: '',
    isManager: 0,
    clients: [],
    users: [],
    fromDate: '',
    toDate: '',
    initialFromDate: '',
    initialToDate: '',
    taskType: '',
    unitProjectId: '',
    unitRegistrationTypeIds: [],
    taskActivityTypes: [],
    task_category: [],
    taskComplianceStatusType: [],
    taskRiskRankType: [],
    taskServiceType: [],
    noInitialBoardDate: 0,
  };
  let extraFilter = { ...defaultFilter };
  let firstTimeLoad = true;
  const filterData = () => {
    if (firstTimeLoad) {
      firstTimeLoad = false;
      return false;
    }
    pageNumber = 1;
    totalPages = 0;
    outlookData = [];
    getTaskOutlookList();
    getTaskOutLookCount();
  };
  $: extraFilter && filterData();

  let totalCount = '';
  let filterCount = '';

  let getTaskOutLookCount = () => {
    if (extraFilter.units.length == 0) {
      return false;
    }
    let queries = {};
    totalCount = '';
    client
      .taskOutlookCount({
        ...queries,
        ...defaultFilter,
        units: extraFilter.units,
        isManager: extraFilter.isManager,
        isTotalCount: 1,
      })
      .then((result) => {
        if (filterCount > result.data.countRecords) {
          totalCount = filterCount;
        } else {
          totalCount = result.data.countRecords;
        }
      });
  };

  export const checkUrl = (params) => {
    if (params.action == 'taskOutlook') {
      let dasaboardData = { ...getDashboardData() };
      if (params.clientId != undefined) {
        dasaboardData.clients = [{ id: params.clientId }];
      }
      if (params.unitId != undefined) {
        dasaboardData.units = [{ id: params.unitId, unitId: params.unitId }];
        dashboardData.taskServiceType = [];
        dashboardData.taskActivityTypes = [];
      }
      setDashboardData(dasaboardData);
    }
  };

  let unitUsers = [];
  let clientUnitUsers = [];
  let registrationTypes = [];
  let taskActivityTypes = [];
  let projects = [];
  let showSaveGroup = false;
  const checkSave = () => {
    showSaveGroup = unitUsers.filter((item) => item.checked == true).length > 0;
  };
  $: unitUsers && checkSave();
  const getUnitDetail = async () => {
    let unitIds = [...extraFilter.units];
    unitIds.map((item) => {
      item.unitId = item.id;
      return item;
    });
    client
      .unitUsers({
        units: unitIds,
        inactiveCondition: 'N',
        inactiveUnitCondition: 'N',
      })
      .then((response) => {
        let detail = response.data;
        unitUsers = detail.users.map((item) => {
          item.name = item.firstName + ' ' + item.lastName;
          item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
          return item;
        });
      });

    client.unitTaskClients({ units: unitIds }).then((response) => {
      clientUnitUsers = response.data.clients.map((item) => {
        item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
        return item;
      });
    });

    if (unitIds.length > 0) {
      client.taskTemplateFilter({ units: unitIds }).then((response) => {
        registrationTypes = response.data.registrationTypes;
        taskActivityTypes = [
          { id: -1, name: 'No Type' },
          ...response.data.taskActivityTypes,
        ]?.map?.((item) => {
          item.checked = extraFilter.taskActivityTypes?.some?.(
            (activity) => activity.id === item.id,
          );
          return item;
        });
      });
    }

    if (unitIds.length > 0) {
      const result = await client.sowServiceType({ units: extraFilter.units });
      const serviceTypeData = result?.data?.payload || [];
      // Ensure that will always checked the checkbox that contain on the extraFilter taskServiceType
      const checkedServiceType = extraFilter?.taskServiceType?.map?.((item) => item.id) || [];
      taskServiceType = serviceTypeData.map((item) => {
        item.checked = checkedServiceType.includes(item.id);
        return item;
      });
    }

    client.getUnitProject({ units: unitIds }).then((response) => {
      if (extraFilter.unitProjectId) {
        extraFilter.unitProjectId = '';
      }
      projects = response.data.projects;
    });
  };

  const unsubscribe = dashboardData.subscribe((dataState) => {
    client.checkAuth().then(() => {
      if (dataState != undefined) {
        let state = { ...dataState };
        let oldExtraFilter = { ...extraFilter };
        if (urlParamExtraFilter) {
          oldExtraFilter = { ...oldExtraFilter, ...urlParamExtraFilter };
          urlParamExtraFilter = null;
        }
        let loadUnit = false;
        if (JSON.stringify(oldExtraFilter.units) != JSON.stringify(state.units)) {
          oldExtraFilter.units = [...state.units];
          loadUnit = true;
        }
        oldExtraFilter.taskComplianceStatusType = state.taskComplianceStatusType;
        oldExtraFilter.taskRiskRankType = state.taskRiskRankType;
        oldExtraFilter.task_category = state.task_category;
        task_category = task_category.map((item) => {
          item.checked = (state.task_category || [])
            .map((taskstatus) => taskstatus.id)
            .includes(item.id);
          return item;
        });
        oldExtraFilter.taskActivityTypes = state.taskActivityTypes;
        oldExtraFilter.taskServiceType = state.taskServiceType;
        if (JSON.stringify(oldExtraFilter.clients) != JSON.stringify(state.clients)) {
          oldExtraFilter.clients = [...state.clients];
        }
        if (JSON.stringify(oldExtraFilter.users) != JSON.stringify(state.users)) {
          oldExtraFilter.users = [...state.users];
        }
        oldExtraFilter.requestKey++;
        oldExtraFilter.fromDate = state.fromDate;
        oldExtraFilter.toDate = state.toDate;
        oldExtraFilter.initialFromDate = state.initialFromDate;
        oldExtraFilter.initialToDate = state.initialToDate;
        if (state.fromDate && state.toDate) {
          fromToRange = state.fromDate + ' to ' + state.toDate;
        }
        if (state.initialFromDate && state.initialToDate) {
          initialFromToRange = state.initialFromDate + ' to ' + state.initialToDate;
        }
        oldExtraFilter.isManager = state.isManager;
        extraFilter = { ...oldExtraFilter };
        if (loadUnit) {
          getUnitDetail();
        } else {
          unitUsers = unitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
            return item;
          });
          clientUnitUsers = clientUnitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
            return item;
          });
        }
      }
    });
  });

  // Abstracting this as a function to call in onDestroy
  const resetFilter = () => {
    fromToRange = '';
    initialFromToRange = '';
    clientUnitUsers = clientUnitUsers.map((item) => {
      item.checked = false;
      return item;
    });
    unitUsers = unitUsers.map((item) => {
      item.checked = false;
      return item;
    });
    registrationTypes = registrationTypes.map((item) => {
      item.checked = false;
      return item;
    });
    taskActivityTypes = taskActivityTypes.map((item) => {
      item.checked = false;
      return item;
    });
    task_category = task_category.map((item) => {
      item.checked = false;
      return item;
    });
    taskComplianceStatusType = taskComplianceStatusType.map((item) => {
      item.checked = false;
      return item;
    });
    // Reset risk rank filter
    taskRiskRankType = taskRiskRankType.map((item) => {
      item.checked = false;
      return item;
    });
    taskServiceType = taskServiceType.map((item) => {
      item.checked = false;
      return item;
    });
    extraFilter = {
      ...extraFilter,
      users: [],
      fromDate: '',
      toDate: '',
      initialFromDate: '',
      initialToDate: '',
      noInitialBoardDate: 0,
      tasks: [],
      clients: [],
      unitRegistrationTypeIds: [],
      taskActivityTypes: [],
      task_category: [],
      taskComplianceStatusType: [],
      taskRiskRankType: [],
      taskServiceType: [],
    };
    /* tagify.removeAllTags() */
    setDashboardData({
      ...getDashboardData(),
      clients: [],
      users: [],
      fromDate: '',
      toDate: '',
      initialFromDate: '',
      initialToDate: '',
      taskComplianceStatusType: [],
      taskRiskRankType: [],
      task_category: [],
      taskServiceType: [],
      taskActivityTypes: [],
    });
  };

  onDestroy(() => {
    unsubscribe();
    unsubscribeOutlookData();
  });

  import Tagify from '@yaireo/tagify';
  import '@yaireo/tagify/dist/tagify.css'; // Tagify CSS
  let tagify;
  let searchTimeout;
  const bindTagify = () => {
    return false;
    var controller;
    tagify = new Tagify(tagifyRef, {
      dropdown: {
        position: 'input',
      },
      enforceWhitelist: true,
      whitelist: [],
    })
      .on('input', (e) => {
        searchTimeout && clearTimeout(searchTimeout);
        if (extraFilter.units.length == 0) {
          return false;
        }
        searchTimeout = setTimeout(() => {
          tagify.settings.whitelist.length = 0;
          controller && controller.abort();
          controller = new AbortController();
          tagify.loading(true).dropdown.hide.call(tagify);
          var detail = e.detail;
          let value = detail.value.trim();

          // client.taskSearch({searchKeyword:value}).then((response) => {
          //   let whitelist=response.data.map(item=>{
          //     item.value=item.name;
          //     return item
          //   });
          //   tagify.settings.whitelist=whitelist;
          //   tagify.loading(false).dropdown.show.call(tagify, value);
          // });

          client
            .taskList(50000, 1, {
              units: extraFilter.units,
              isManager: extraFilter.isManager,
              comeFrom: 'outlookAutoComplete',
              searchKeyword: value,
            })
            .then(async (result) => {
              let whitelist = [];
              result.valueArray.map((item) => {
                whitelist.push({
                  id: item.id,
                  value: item.name,
                });
              });
              tagify.settings.whitelist = whitelist;
              tagify.loading(false).dropdown.show.call(tagify, value);
            });
        }, 750);
      })
      .on('change', (e) => {
        extraFilter.tasks = tagify.value;
      });
  };
  let tagifyRef;
  let fromToRange = '';
  let initialFromToRange = '';

  import TaskReasonModal from '../TaskReasonModal.svelte';
  let taskReasonModal;
  let editTaskModal;
  const editTask = (taskId, comeFrom) => {
    editTaskModal.show(taskId, comeFrom);
  };
  let selectedTypeId = 2;
  let typeId = 2;
  let selectedTasks = [];
  let comeFromDetail = false;
  setContext('taskAction', (params) => {
    if (params.type == 'saveTask') {
      filterData();
    }
    if (params.type == 'deleteTask') {
      selectedTasks = [{ id: params.id }];
      comeFromDetail = true;
      showDialog({
        isDeleteModel: typeId == 2,
        type: 'confirm',
        title: '',
        message: 'Are you sure ?',
        okFunc: () => {
          if (typeId == 2) {
            taskReasonModal.showModal();
          }
        },
      });

      return;
    }
    if (editTaskModal != undefined) {
      editTaskModal.hide();
    }
  });
  let createGroupModal;
  let groupUsers = [];
  const saveGroup = () => {
    groupUsers = extraFilter.users;
    createGroupModal = new Modal(document.getElementById('creatGroupModal'), {
      keyboard: false,
    });
    createGroupModal.show();
  };
  let taskGroupModal;
  const showGroup = () => {
    taskGroupModal.show();
  };
  let createFilterGroupModal;

  let ref;
  let tableData = [];
  const getMaster = () => {
    client
      .getMasterData()
      .then((response) => {
        setMasterData(response.data);
      })
      .catch((err) => {});
  };

  const changeExpandLabel = () => {
    expandLabels = ref
      .getData()
      .filter((item) => item.driver)
      .map((item) => item.label);
    client
      .userUpdateOutlookSetting({
        label: expandLabels,
      })
      .then((response) => {
        setOutlookData({
          outlookSetting: expandLabels,
        });
      });
  };
  let style = `
	body:{
	  background:red;
	}
  `;

  let clickSearch = '';
</script>

<div class="filter-content top-menu-filter">
  <div class="d-flex flex-row justify-content-between">
    <div class="">
      <div class="d-flex flex-wrap flex-row align-items-center">
        <DropDown
          title={extraFilter.taskType == undefined || extraFilter.taskType == ''
            ? 'Client/Internal'
            : taskType[extraFilter.taskType - 1].text}
          option={taskType}
          Style="select-block"
          titleChanged={true}
          on:onSelect={(event) => {
            extraFilter.taskType = event.detail.id;
            extraFilter.unitProjectId = 0;
          }}
        />
        {#if extraFilter.taskType == 2}
          <DropDown
            title="All Project"
            searchbox={true}
            option={projects}
            Style="select-block projects-block"
            titleChanged={true}
            on:onSelect={(event) => {
              extraFilter.unitProjectId = event.detail.id;
            }}
          />
        {/if}
        <DropDown
          checkbox={true}
          searchbox={true}
          active={false}
          title="Assignee"
          option={unitUsers}
          Style="select-block"
          checkedFields="checked"
          removeIcon={true}
          on:onClear={(event) => {
            extraFilter.users = [];
            setTimeout(() => {
              setDashboardData({
                ...getDashboardData(),
                users: extraFilter.users,
              });
            }, 1000);
          }}
          on:onSelect={(event) => {
            extraFilter.users = event.detail.map((item) => {
              item.id = item.userId;
              return item;
            });
            setTimeout(() => {
              setDashboardData({
                ...getDashboardData(),
                users: extraFilter.users,
              });
            }, 1000);
          }}
        />
        {#if showSaveGroup == true}
          <button
            type="button"
            class="task-filter-icon ms-0 btn-primary border-0 px-2 ms-2 rounded font-size-13 text-nowrap"
            on:click={() => {
              saveGroup();

              setTimeout(() => {
                createFilterGroupModal.show(groupUsers, {
                  userId: '',
                  id: '',
                  readonly: '',
                  name: '',
                  users: groupUsers,
                });
              }, 500);
            }}
          >
            Save Group
          </button>
        {/if}
        <button
          type="button"
          class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
          on:click={showGroup}
        >
          My Groups
        </button>
        <div class="customer-picker ms-1">
          <DropDown
            checkbox={true}
            searchbox={true}
            active={false}
            title="Client"
            option={clientUnitUsers}
            Style="select-block "
            checkedFields="checked"
            removeIcon={true}
            on:onClear={(event) => {
              extraFilter.clients = [];
              setTimeout(() => {
                setDashboardData({
                  ...getDashboardData(),
                  clients: event.detail,
                });
              }, 1000);
            }}
            on:onSelect={(event) => {
              extraFilter.clients = event.detail;
              setTimeout(() => {
                setDashboardData({
                  ...getDashboardData(),
                  clients: event.detail,
                });
              }, 1000);
            }}
          />
        </div>

        {#if extraFilter.units.length > 0}
          <div class="customer-picker ms-1">
            <DropDown
              checkedFields="checked"
              searchbox={true}
              checkbox={true}
              title="Registration type"
              option={registrationTypes}
              Style="select-block"
              titleChanged={true}
              removeIcon={true}
              on:onClear={(event) => {
                extraFilter.unitRegistrationTypeIds = [];
              }}
              on:onSelect={(event) => {
                extraFilter.unitRegistrationTypeIds = event.detail;
              }}
            />
          </div>
          <!-- Service Type filter -->
          {#if taskServiceType.length > 0}
            <DropDown
              searchbox={true}
              checkbox={true}
              deleteSelected={true}
              titleChanged={false}
              title="Service Type"
              checkedFields="checked"
              removeIcon={true}
              option={taskServiceType}
              Style="select-block"
              on:onClear={() => {
                setDashboardData({
                  ...getDashboardData(),
                  taskServiceType: [],
                });
              }}
              on:onSelect={(item) => {
                setDashboardData({
                  ...getDashboardData(),
                  taskServiceType: item.detail,
                });
              }}
            />
          {/if}
          <div class="customer-picker ms-1">
            <DropDown
              searchbox={true}
              checkbox={true}
              checkedFields="checked"
              title="Activity Type"
              option={taskActivityTypes}
              Style="select-block"
              titleChanged={true}
              removeIcon={true}
              on:onClear={() => {
                setDashboardData({
                  ...getDashboardData(),
                  taskActivityTypes: [],
                });
              }}
              on:onSelect={(event) => {
                setDashboardData({
                  ...getDashboardData(),
                  taskActivityTypes: event.detail,
                });
              }}
            />
          </div>
          <!-- Risk Rank filter -->
          <div class="customer-picker ms-1">
            <DropDown
              showIcon={true}
              checkbox={true}
              deleteSelected={true}
              titleChanged={false}
              active={true}
              title="Risk Rank"
              checkedFields="checked"
              removeIcon={true}
              on:onClear={() => {
                setDashboardData({
                  ...getDashboardData(),
                  taskRiskRankType: [],
                });
              }}
              on:onSelect={(item) => {
                setDashboardData({
                  ...getDashboardData(),
                  taskRiskRankType: item.detail,
                });
              }}
              option={taskRiskRankType}
              Style="select-block"
            />
          </div>
        {/if}
        <div
          class="date-picker"
          style="position: relative;"
        >
          <DatePicker
            mode="range"
            showMonths="2"
            placeholder="Select Due Date(s)"
            value={fromToRange}
            bind:this={datePickerRef}
            on:close={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                event = [];
                fromToRange = value.detail[1];
                extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
                extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
                setDashboardData({
                  ...getDashboardData(),
                  fromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
                  toDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
                });
              }
            }}
            on:change={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                return;
              }
              fromToRange = value.detail[1];
              extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
              extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
              setDashboardData({
                ...getDashboardData(),
                fromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
                toDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
              });
            }}
          />
          {#if extraFilter.fromDate != '' || extraFilter.toDate != ''}
            <button
              class="remove-btn bg-transparent border-0"
              on:click={() => {
                datePickerRef.clear();
              }}
            >
              <img
                alt=""
                src="/images/close.svg"
              />
            </button>
          {/if}
        </div>

        <!-- Initial board date filter -->
        <div
          class="date-picker"
          style="position: relative;"
        >
          <DatePicker
            mode="range"
            showMonths="2"
            placeholder="Select Initial Board Date(s)"
            value={initialFromToRange}
            bind:this={initialDatePickerRef}
            on:close={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                event = [];
                initialFromToRange = value.detail[1];
                extraFilter.initialFromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
                extraFilter.initialToDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
                setDashboardData({
                  ...getDashboardData(),
                  initialFromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
                  initialToDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
                });
              }
            }}
            on:change={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                return;
              }
              initialFromToRange = value.detail[1];
              extraFilter.initialFromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
              extraFilter.initialToDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
              setDashboardData({
                ...getDashboardData(),
                initialFromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
                initialToDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
              });
            }}
          />
          {#if extraFilter.initialFromDate || extraFilter.initialToDate}
            <button
              class="remove-btn bg-transparent border-0"
              on:click={() => {
                initialDatePickerRef.clear();
              }}
            >
              <img
                alt=""
                src="/images/close.svg"
              />
            </button>
          {/if}
        </div>

        <!-- No Initial Board Date checkbox -->
        <div class="checkbox c-checkbox px-1 filters">
          <label class="font-size-12"
            ><input
              type="checkbox"
              checked={extraFilter.noInitialBoardDate == 1}
              on:change={(event) => {
                extraFilter.noInitialBoardDate = event.target.checked ? 1 : 0;
                extraFilter.initialFromDate = '';
                extraFilter.initialToDate = '';
                initialFromToRange = '';
                setDashboardData({
                  ...getDashboardData(),
                  initialFromDate: '',
                  initialToDate: '',
                });
              }}
            />
            <span class="check-img"></span>
            No Initial Board Date
          </label>
        </div>

        <!-- <button
				  on:click={()=>{
					dashboardLeftObj.viewAll(extraFilter.clients)
				  }}
				  type="button"
				  class="btn btn-link color-blue mb-0 font-size-12 p-0 shadow-none border-0 bg-transparent "><svg fill="#206bc4" class="mx-1 svelte-dhog5f" width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M8.04898 8.28698L14.299 1.99997L10.709 1.99997L10.709 -2.41836e-05L17.709 -2.47955e-05L17.709 6.99997L15.709 6.99997L15.709 3.41997L9.46399 9.69898L8.04898 8.28698Z" fill="#206bc4"></path><path d="M8 1.70599V3.70599H2V15.706H14V9.70599H16V17.706H0V1.70599H8V1.70599Z" fill="#206bc4"></path></svg>
				  View All</button> -->

        <button
          type="button"
          class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-2 bg-transparent border-0"
          on:click={() => resetFilter()}
        >
          <img
            class="icon-14 me-2"
            alt=""
            src="/images/reset.svg"
          />
          Reset Filter
        </button>
      </div>
    </div>

    <div class="d-flex flex-row justify-content-end right-action-btn xposition-relative">
      <div
        class="d-flex flex-wrap flex-row align-items-center"
        sstyle="padding-right: 0px;position: absolute !important;right: 0;z-index:0;     margin-right: 0.5rem;"
      >
        <div
          class="input-block-search position-relative input-outlook-search"
          style="overflow:hidden;"
        >
          <span
            class="position-absolute"
            style="z-index: 0; right: 3px; top: 3px;"
          >
            <span
              on:click={() => {
                if (clickSearch?.trim()?.length) {
                  extraFilter.searchKeyword = clickSearch;
                }
              }}
              style="font-size: 10px;"
              class="btn btn-primary p-1"
              >Search
            </span>
            {#if !!clickSearch?.trim()?.length}
              <span
                on:click={() => {
                  if (extraFilter.searchKeyword) {
                    extraFilter.searchKeyword = '';
                  }
                  clickSearch = '';
                }}
                style="font-size: 10px; font-family: sans-serif;"
                class="btn btn-secondary py-1 px-2 d-inline-block align-top"
              >
                X
              </span>
            {/if}
          </span>
          <!-- bind:value={extraFilter.searchKeyword} -->
          <input
            bind:value={clickSearch}
            placeholder="Search task"
            class="mb-0 tagify--outside form-control position-absolutes p-0 bg-white"
            type="text"
            style="min-width: 230px;"
          />
        </div>
        <button
          disabled={extraFilter.units.length == 0}
          on:click={() => downloadCsv('client')}
          class="cursor mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
        >
          <svg
            class="me-1 icon-16"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
            ><g
              ><g
                ><path
                  d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                /></g
              ></g
            ><g
              ><g
                ><path
                  d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                /></g
              ></g
            ></svg
          >
          Client Export
        </button>
        <button
          disabled={extraFilter.units.length == 0}
          on:click={() => downloadCsv('list')}
          class="cursor mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
        >
          <svg
            class="me-1 icon-16"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
            ><g
              ><g
                ><path
                  d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                /></g
              ></g
            ><g
              ><g
                ><path
                  d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                /></g
              ></g
            ></svg
          >
          List Export
        </button>

        <button
          disabled={extraFilter.units.length == 0}
          on:click={() => {
            window.print();
          }}
          class="cursor mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
        >
          <svg
            class="me-1"
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.85 3.44L8.57 0.14L8.22 0H0.5L0 0.5V6H1V1H7V4.5L7.5 5H11V6H12V3.8L11.85 3.44ZM8 4V1L11 4H8ZM0.5 7L0 7.5V13.5L0.5 14H11.5L12 13.5V7.5L11.5 7H0.5ZM11 12V13H1V8H11V12ZM3 11H2.68V12H2V9H3.06C3.81 9 4.19 9.36 4.19 10C4.19194 10.136 4.16433 10.2708 4.10908 10.3951C4.05383 10.5195 3.97226 10.6303 3.87 10.72C3.62218 10.9132 3.31397 11.0124 3 11ZM2.94 9.55H2.68V10.48H2.94C3.3 10.48 3.48 10.32 3.48 10.01C3.48 9.7 3.3 9.55 2.94 9.55ZM7 11.58C7.14769 11.4345 7.26317 11.2597 7.33897 11.0667C7.41476 10.8738 7.44918 10.6671 7.44 10.46C7.44 9.46 6.91 9 5.84 9H4.78V12H5.84C6.05153 12.0102 6.26298 11.9784 6.46211 11.9063C6.66123 11.8342 6.84406 11.7233 7 11.58ZM5.45 11.45V9.55H5.78C5.90755 9.5419 6.0354 9.55989 6.15576 9.60287C6.27612 9.64586 6.38644 9.71293 6.48 9.8C6.56476 9.88901 6.63061 9.99426 6.67357 10.1094C6.71654 10.2246 6.73573 10.3472 6.73 10.47C6.74498 10.7336 6.65511 10.9924 6.48 11.19C6.38845 11.2776 6.28013 11.3458 6.16156 11.3905C6.04298 11.4352 5.9166 11.4554 5.79 11.45H5.45ZM9.9 10.84H8.93V12H8.25V9H9.99V9.55H8.93V10.29H9.9V10.84Z"
            />
          </svg>

          Print
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex d-flex-row justify-content-between align-items-center mt-2">
    <div class="d-flex flex-row align-items-center">
      {#if outlookData.length > 0}
        <!-- <button class="p-0 reset-filter color-blue d-flex flex-row align-items-center  text-start bg-transparent border-0" on:click={()=>{
				ref.toggleRow()
			  }}>
			  Expand/Collapse
			  </button> -->
        <DropDown
          checkbox={false}
          active={true}
          title="Action"
          titleClass="text-primary"
          on:onSelect={(item) => {
            selectAction(item.detail.id);
          }}
          option={[
            { id: 1, text: 'Expand Month(s)' },
            { id: 2, text: 'Collapse Month(s)' },
          ]}
          Style="select-block bulk-action-drop"
        />
      {/if}
      <!-- Task status filter -->
      <DropDown
        searchbox={true}
        checkbox={true}
        checkedFields="checked"
        title="Task Status"
        option={task_category}
        Style="select-block"
        titleChanged={true}
        removeIcon={true}
        on:onClear={() => {
          setDashboardData({
            ...getDashboardData(),
            task_category: [],
          });
        }}
        on:onSelect={(event) => {
          setDashboardData({
            ...getDashboardData(),
            task_category: event.detail,
          });
        }}
      />
      <!-- Compliance Status filter -->
      <DropDown
        searchbox={true}
        checkbox={true}
        checkedFields="checked"
        title="Compliance Status"
        option={taskComplianceStatusType}
        Style="select-block"
        titleChanged={true}
        removeIcon={true}
        on:onClear={() => {
          setDashboardData({
            ...getDashboardData(),
            taskComplianceStatusType: [],
          });
        }}
        on:onSelect={(event) => {
          setDashboardData({
            ...getDashboardData(),
            taskComplianceStatusType: event.detail,
          });
        }}
      />
    </div>
    <div class="d-flex flex-row align-items-center">
      <span class="text-nowrap me-2"
        >{filterCount > 0 && totalCount > 0
          ? '(' + filterCount + ' of ' + totalCount + ' Tasks)'
          : ''}</span
      >
      {#if columnLoaded}
        <DropDown
          checkbox={true}
          active={false}
          title="Fields"
          option={allColumns.filter((item) => item.key != 'label')}
          labelFields="label"
          checkedFields="checked"
          Style="select-block "
          dropDownStyle={' dropdown-menu-end right-position'}
          on:onSelect={(item) => {
            let oldColumns = [];
            for (var i in allColumns) {
              if (
                allColumns[i].key == 'label' ||
                searchKeyByValue(item.detail, 'key', allColumns[i].key) !== -1
              ) {
                oldColumns.push(allColumns[i]);
                allColumns[i].checked = true;
              } else {
                allColumns[i].checked = false;
              }
            }
            setTimeout(() => {
              initPopupOver();
            }, 500);
            columns = oldColumns;
            client.outlookGridColumnSave({
              columns: allColumns.filter((item) => !['label'].includes(item.key)),
            });
            setColumnUnitWidth();
            tableColumns = allColumns.map((item) => {
              item.title = item.name;
              item.field = item.key;
              item.visible = item.checked;
              return item;
            });
            ref.setColumns(tableColumns);
            ref.refreshData();
          }}
        />
      {/if}
    </div>
    <!-- <GridSearch
			btnExport={true}
			value={extraFilter.searchKeyword}
			handleInput={(e)=>{
			  extraFilter.searchKeyword = e.target.value;
			}}
			onAction={(params)=>{
			  if(params=="export"){
				downloadCsv()
			  }
			}}
			placeholder="Search Task/regulation"
		  /> -->
  </div>
</div>
<div
  class="page-content table-content task-outlook-grid {extraFilter.units.length == 0
    ? 'w-100'
    : 'task-outlook-content'}"
>
  {#if extraFilter.units.length == 0}
    <div
      class="d-flex flex-row justify-content-center page-title me-3 align-items-center h-100 font-weight-300 no-items"
    >
      Please select a business unit
    </div>
  {:else if outlookData.length == 0 && isPaginationLoading == false}
    <div
      class="d-flex flex-row justify-content-center page-title me-3 align-items-center h-100 font-weight-300 no-items"
    >
      No results
    </div>
  {:else if isPaginationLoading}
    <div
      class="d-flex flex-row justify-content-center page-title me-3 align-items-center h-100 font-weight-300 no-items"
    >
      <Loader />
    </div>
  {:else if columnLoaded}
    <DataGrid
      rowFormatter={(row) => {
        var data = row.getData();
        if (data.className != '') {
          row.getElement().classList.add(data.className);
        }
      }}
      rowClickable={true}
      rowClickCallaback={(e, data) => {
        e.stopImmediatePropagation();
        if (data.id) {
          editTask(data.id);
        }
      }}
      expandCollepseCallaback={(flag, data) => {
        loadingData.set(true);
        setTimeout(() => {
          changeExpandLabel();
        }, 250);
      }}
      expanded={false}
      dataTree={true}
      tableId="list"
      bind:this={ref}
      columns={tableColumns}
      tableData={tableData}
      pagination={false}
    />
  {/if}
</div>
<EditTaskModal bind:this={editTaskModal} />
<TaskReasonModal
  bind:this={taskReasonModal}
  handleClick={(params) => {
    //delete task
    if (selectedTypeId == 2) {
      client
        .taskDelete({
          tasks: selectedTasks,
          reason: params.reason,
          comeFrom: comeFromDetail ? 'detail' : '',
        })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
          if (editTaskModal != undefined) {
            editTaskModal.hide();
          }
        })
        .catch((err) => {
          showDialog({ message: err.message });
        });
    }
    comeFromDetail = false;
  }}
/>

<CreateGroup
  bind:this={createFilterGroupModal}
  groupUsers={groupUsers}
  saveGroup={(event) => {
    client
      .taskFilterGroupSave(event)
      .then(async (result) => {
        createGroupModal.hide();
        showSaveGroup = false;
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  }}
/>
<TaskGroup
  bind:this={taskGroupModal}
  showGroup={(flag, event) => {
    if (flag == 'edit') {
      saveGroup();
      setTimeout(() => {
        createFilterGroupModal.show(event.users, {
          userId: '',
          userId: '',
          id: event.id,
          readonly: event.readonly,
          name: event.name,
          users: event.users,
        });
      }, 100);
      return false;
    }
    let oldUnitUsers = unitUsers;
    oldUnitUsers.map((item) => (item.checked = false));
    extraFilter.users = event.users.map((item) => {
      item.userId = item.id;
      let dbKey = searchKeyByValue(oldUnitUsers, 'userId', item.userId);
      if (dbKey != -1) {
        oldUnitUsers[dbKey].checked = true;
      }
      return item;
    });
    unitUsers = oldUnitUsers;
    // filterData()
  }}
/>

<style lang="scss">
  .remove-btn {
    /*display: none;*/
    position: absolute;
    right: -3px;
    top: -4px;
    width: 17px;
    background: $lead-color !important;
    width: 16px;
    height: 16px !important;
    border-radius: 6px !important;
    line-height: 0px;
    padding: 0px;
    z-index: 1;

    img {
      width: 8px;
    }
    &:hover {
      background: $black-color !important;
    }
  }
  .save-group {
    border-radius: 0 4px 4px 0;
    margin-left: -5px !important;
  }
  .top-menu-filter {
    border-bottom: 1px solid $input-border-color;
    padding: 0.5rem 1rem;
  }

  /* custom switch form */

  .btn-export {
    &:hover {
      color: $blue-color;
      svg {
        fill: $blue-color;
      }
    }
  }
  .tagify--outside {
    z-index: 0;
  }

  .tagify--outside .tagify__input {
    order: -1;
    flex: 100%;
    border: 1px solid $blue-color;
    margin-bottom: 1em;
    transition: 0.1s;
  }

  .tagify--outside .tagify__input:hover {
    border-color: var(--tags-hover-border-color);
  }
  .tagify--outside.tagify--focus .tagify__input {
    transition: 0s;
    border-color: $blue-color;
  }
  .tagify__input {
    margin: 0 0 0 5px;
  }
  .no-items {
    font-weight: 300 !important;
  }
  .date-picker {
    width: 230px;
  }

  .task-filter-icon {
    img {
      width: 16px;
      height: 16px;
    }
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>
